import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getTrans as T } from "../../../../Shared/Language";
import TosterService from "../../../../Services/Toster-Service/TosterService";
import { getWFHDetails } from "./WfhSerevice";
import { LoaderContext } from "../../../../Services/Loader_Provider_Service/LoadingContext";
import WfhManagerReport from "./WfhCommon/WfhManagerReport";
import WfhNavBarItems from "./WfhCommon/WfhNavBarItems";
import moment from "moment";

function MyPendingWfh() {
  const toster = useRef(null);
  const [pendingWFHData, setPendingWFHData] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const { showLoading, hideLoading } = useContext(LoaderContext);
  useEffect(() => {
    getPendingWFHData();
  }, []);

  async function getPendingWFHData() {
    showLoading();
    const param = {
      OrgId: userDetails?.OrgId,
      LoggedInUserId: userDetails?.EmpId,
      WFHid: 0,
      EmpId: userDetails?.EmpId,
    };
    try {
      const data = await getWFHDetails(param);
      let projectDetailData = data?.Data;
      let pendingWFH = projectDetailData?.filter(
        (item) => item.WFHStatusId === 104
      );
      setPendingWFHData(pendingWFH);
      hideLoading();
    } catch {
      hideLoading();
    }
  }

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid">
        <div className="row">
          <div className="form-head d-flex flex-wrap align-items-center">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">{T("My Leaves")}</h2>
              <p className="text-light">Lorem ipsum dolor sit amet</p>
            </div>
            <div className="rightside-tabs">
              <WfhNavBarItems />
            </div>
          </div>

          <div className="col-xl-8">
            <div className="leave-card tile-grid tile-grid-v1">
              <div className="card">
                <div className="tab-tabsa">
                  <div className="me-auto">
                    <Link to="MyWfh">
                      <h2 className="font-w600 mb-0">Upcoming Leave</h2>
                    </Link>
                  </div>
                  <div className="me-auto">
                    <Link to="MyWfhCompleted">
                      <h2 className="font-w600 mb-0">Completed Leave</h2>
                    </Link>
                  </div>
                  <div className="me-auto">
                    <Link to="MyPendingWfh">
                      <h2 className="font-w600 mb-0 h2active">Pending Leave</h2>
                    </Link>
                  </div>
                  <div className="me-auto side-filter">
                    <Link to="">
                      <img src="images/org-img/leave/filter.svg" />
                    </Link>
                  </div>
                </div>
              </div>

              <div className="card bottom-card">
                <div className="card-body pb-0">
                  <div className="row">
                    <div className="col-xl-2">
                      <img
                        src="images/org-img/leave/upcoming.png"
                        className="w-100"
                      />
                    </div>
                    <div className="col-xl-4 p-3">
                      <div className="media-body px-0">
                        <h4 className="mt-0 mb-0 fss-17">
                          <a className="text-black" href="event.html">
                            Reference site about Lorem Ipsum.
                          </a>
                        </h4>
                        <span className="mt-0 mb-3 fs-14 datecol">
                          Planned Leave
                        </span>
                      </div>
                    </div>
                    <div className="col-xl-3 p-3">
                      <p className="m-0">
                        <b>From </b>:15-11-22
                      </p>
                      <p className="m-0">
                        <b>To </b>:21-11-22
                      </p>
                      <p className="m-0">
                        <b>Half Day </b>: No
                      </p>
                    </div>
                    <div className="col-xl-3 p-3">
                      <p className="m-0">
                        <b>Action on </b>:16-11-22
                      </p>
                      <p className="m-0">
                        <b>Action By </b>: Arun Mishra
                      </p>
                      <p className="status-p1">
                        <a>
                          <i
                            className="fa fa-check-square-o"
                            aria-hidden="true"
                          ></i>{" "}
                          Pending
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {pendingWFHData.map((wfhData, index) => {
                return (
                  <div className="card bottom-card">
                    <div className="card-body pb-0">
                      <div className="row">
                        <div className="col-xl-2">
                          <img
                            src="images/org-img/leave/upcoming.png"
                            className="w-100"
                          />
                        </div>
                        <div className="col-xl-4 p-3">
                          <div className="media-body px-0">
                            <h4 className="mt-0 mb-0 fss-17">
                              <a className="text-black" href="event.html">
                                {wfhData?.Reason}.
                              </a>
                            </h4>
                            <span className="mt-0 mb-3 fs-14 datecol">
                              {wfhData?.LeaveStatusName}
                            </span>
                          </div>
                        </div>
                        <div className="col-xl-3 p-3">
                          <p className="m-0">
                            <b>From </b>:
                            {moment(wfhData?.StartDate).format("MMM DD YYYY")}
                          </p>
                          <p className="m-0">
                            <b>To </b>:
                            {moment(wfhData?.EndDate).format("MMM DD YYYY")}
                          </p>
                          <p className="m-0">
                            <b>Half Day </b>:
                            {wfhData.IsHalfDay == false && <span>No</span>}{" "}
                            {wfhData.IsHalfDay == true && <span>Yes</span>}
                          </p>
                        </div>
                        <div className="col-xl-3 p-3">
                          <p className="m-0">
                            <b>Action on </b>:16-11-22
                          </p>
                          <p className="m-0">
                            <b>Action By </b>: Arun Mishra
                          </p>
                          <p className="status-p1">
                            <a>
                              <i
                                className="fa fa-check-square-o"
                                aria-hidden="true"
                              ></i>{" "}
                              {wfhData?.LeaveStatusName}
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col-xl-4">
            <WfhManagerReport />
          </div>
        </div>
      </div>
      <div className="modal fade" id="contact-manager">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title m-auto">
                Contact Your Reporting Manager htmlFor Any Leave Clarifications
              </h5>
            </div>
            <div className="modal-body text-center">
              <form>
                <div className="form-group text-left">
                  <label>Repoting Manager</label>
                  <select className="default-select form-control wide mb-3">
                    <option selected disabled>
                      Select reporting manager
                    </option>
                    <option>Arun Mishra</option>
                    <option>Pragya Tiwari</option>
                    <option>Alisha Goyal</option>
                  </select>
                </div>
                <div className="form-group text-left">
                  <label className="mt-3">Reason</label>
                  <textarea
                    rows="4"
                    cols="1"
                    className="form-control"
                  ></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
              >
                Decline
              </button>
              <button type="button" className="btn btn-primary">
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
      <TosterService ref={toster} />
    </div>
  );
}

export default MyPendingWfh;
